import Hero from "@/components/site/Hero";
import QuickStart from "@/components/site/QuickStart";
import LocalBand from "@/components/site/LocalBand";
import MissingBand from "@/components/site/MissingBand";
import MemorialSearch from "@/components/site/MemorialSearch";
import CelebrateALife from "@/components/site/CelebrateALife";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import CategoryGrid from "@/components/site/CategoryGrid";
import Spotlight from "@/components/site/Spotlight";
import TodayMemories from "@/components/site/TodayMemories";
import MemoryWall from "@/components/site/MemoryWall";
import ResearchCorner from "@/components/site/ResearchCorner";
import CemeteriesPreview from "@/components/site/CemeteriesPreview";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <QuickStart />
      <LocalBand />
      <MissingBand />
      <MemorialSearch />
      <CelebrateALife />
      <Marquee />
      <Manifesto />
      <CategoryGrid />
      <Spotlight />
      <TodayMemories />
      <MemoryWall />
      <ResearchCorner />
      {/* Cemetery Searches moved to the bottom per the new brief */}
      <CemeteriesPreview />
    </main>
  );
}
